// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38RO7","title":"styles_title__1djQI"};